import store from "@/store";

export default {
  puede(permiso) {
    let puede = false;

    if (permiso) {
      let usuario = store.state.seguridad.usuario;
      if (usuario) {
        let permisos = usuario.perms;
        for (let i = 0; i < permisos.length; i++) {
          let perm = permisos[i];
          if (perm === "ControlTotal[Dev]" || permiso === perm) {
            puede = true;
            break;
          }
        }
      }
    }
    return puede;
  }
};
